import axios from "axios";

export default function OfferstatusListService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/offer_status",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
